import Vue from 'vue'
import Vuex from 'vuex'
import IberoHelpers from '@/store/helpers.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        configAuth: {
            tenant: 'ba5b0a4d-6c68-4ac3-9d6e-c5b5a12a9d69',
            clientId: 'e289d29f-4de8-43a1-ad0f-e9ac9aa2eebc',
            redirectUri: process.env.VUE_APP_URL_URI,
            redirectUriLogout: process.env.VUE_APP_URL_URILOGOUT,
            cacheLocation: 'localStorage',
        },
        ApiIbero: {
            //LocalIP: 'https://api.ipify.org?format=json', 
            WSParametric: process.env.VUE_APP_URL_WSPARAMETRIC,
            WSUtilitary: process.env.VUE_APP_URL_WSUTILITARY,
            WSAudit: process.env.VUE_APP_URL_WSAUDIT,
            WSIceBerg: process.env.VUE_APP_URL_ICEBERG,
        },
        linksRedirect: {
            redMine: 'http://redmineibero.ibero.edu.co:81/redmine/login',
            PTEmple: process.env.VUE_APP_URL_PTEMPLE,
            PTEstud: process.env.VUE_APP_URL_PTESTUD,
        },
        dateFormat: 'dd/MM/yyyy',
        filesIbero: {
            sizeFiles: 103000000,
            extFiles: 'gif|jpg|jpeg|png|docx|doc|pdf'
        },
        linkTermiCondi: 'https://ibero.edu.co/tratamiento-uso-datos-personales',
        linkComproMatricula: 'https://services.ibero.edu.co/Files/General/CompromisoMatriculaIberoamericana.pdf',
        liksActas: [
            { name: 'Acta de Compromiso Posgrado', linkActa: 'https://services.ibero.edu.co/Files/General/ACTACOMPROMISOPOSGRADO.pdf' },
            { name: 'Acta de Compromiso Pregrado', linkActa: 'https://services.ibero.edu.co/Files/General/ACTACOMPROMISOPREGRADO.pdf' },
            { name: 'Acta Compromiso Sena', linkActa: 'https://services.ibero.edu.co/Files/General/ACTACOMPROMISOSENA.pdf' },
            { name: 'Acta Compromiso No Sena', linkActa: 'https://services.ibero.edu.co/Files/General/ACTACOMPROMISONOSENA.pdf' },
            { name: 'Autorización Verificación Académica', linkActa: 'https://services.ibero.edu.co/Files/General/AutorizacionVerificacionAcademica.pdf' }
        ],
        txtActas: '<div style="text-align: justify;" class="alert alert-light" role="alert">Apreciado aspirante, si por fuerza mayor no cuenta con algún documento de admisión, es necesario diligenciar la siguiente acta de compromiso, lo cual lo condiciona a tener calidad de ASISTENTE en la Institución. <div style="font-size: 9px; line-height: 10pt;"><strong>Asistente.</strong> Es aquel participante que cursa uno a varios cursos o créditos de programas académicos de la Iberoamericana, hasta un máximo equivalente a dieciocho (18) créditos, de los cuales únicamente se les certificará asistencia a los aprobados y no son conducentes a la obtención de título alguno. Este participante no requiere cumplir con la totalidad de los requisitos establecidos para el estudiante regular toda vez que la participación en sus cursos no lo conduce a la obtención del título.</div></div>',
        modalBody: '',
        localInf: [],
        IberoPresen: [
            { id: '12', title: 'Formulario de Inscripción', detail: 'Accede', link: '/formulario-inscripcion/PortalWeb', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/formulario_inscripcion.jpg', color: 'red', target: '_self' },
            { id: '14', title: 'Inscripción de Documentos', detail: 'Accede', link: '/archivos-inscripcion', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/inscripcion_documentos.jpg', target: '_self' },
            { id: '13', title: 'Descarga tus diplomas', detail: 'Accede', link: '/diplomas', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/descargar_diploma.jpg', target: '_self' },
            { id: '1', title: 'Recibo de Pago', detail: 'Accede', link: 'https://www.ibero.edu.co/solicitar-copia-de-recibo-de-pago/', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/recibo_pago.jpg', target: '_blank' },
            { id: '24', title: 'Formulario Atención de PQRs', detail: 'Accede', link: '/formulario-pqrs', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/Form_atencion_PQRS.jpg', target: '_self' },
            { id: '28', title: 'Consulta el estado de tu petición', detail: 'Accede', link: '/Estados_Casos', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/consulta_estado_peticion.jpg', target: '_self' },
            { id: '16', title: 'Recibo de Inscripción', detail: 'Accede', link: '/recibo-inscripcion', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/recibo_inscripcion.jpg', target: '_self' },
            { id: '2', title: 'Certificaciones', detail: 'Accede', link: '/solicitar-certificados', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/Certificaciones.jpg' },
            { id: '26', title: 'Comprobante de Pago Certificados', detail: 'Accede', link: '/recibo-pago-certificado', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/comprobante_pago_certificados.jpg', target: '_self' },
            //{ id: '3', title: 'Restablece tu contraseña de email', detail: 'Accede', link: 'https://www.ibero.edu.co/restablecimiento-de-contrasena-de-correo-electronico/', img: 'https://www.ibero.edu.co/wp-content/uploads/2019/08/recuperar_clave_del_correo.png', target: '_blank' },
            { id: '4', title: 'Restablece tu contraseña de zafiro', detail: 'Accede', link: '/Contrasena-zafiro', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/restablecer_contrase%C3%B1a_zafiro.jpg', target: '_blank' },
            { id: '5', title: 'Aula virtual Ibero', detail: 'Aula Virtual', link: 'https://aulavirtual.ibero.edu.co/login/index.php', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/Aula_virtual.jpg', target: '_blank' },
            { id: '6', title: 'Zafiro Ibero', detail: 'Zafiro', link: 'http://autoservicio.iberoamericana.edu.co:8885/PROD/twbkwbis.P_GenMenu?name=homepage', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/Zafiro.jpg', target: '_blank' },
            { id: '7', title: 'Guía de consulta de notas Zafiro', detail: 'Guía de consulta - Zafiro', link: 'https://aulavirtual.iberoamericana.edu.co/recursosel/documentos_para-descarga/Manual_Ingreso%20a%20Zafiro_Mapa%20del%20Sitio.pdf', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/consulta_notas_zafiro.jpg', target: '_blank' },
            { id: '8', title: 'Consulta estado financiero Ibero', detail: 'Portal financiero – pago en línea', link: 'https://icebergprod.ibero.edu.co:17220/iceberg-pf/', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/consulta_estado_financiero.jpg', target: '_blank' },
            { id: '9', title: 'Consulta de homologaciones Ibero', detail: 'Ver video', link: 'https://aulavirtual.iberoamericana.edu.co/recursosel/te_guiamos/', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/consulta_homologaciones.jpg', target: '_blank' },
            { id: '10', title: 'Sistema de biblioteca Ibero', detail: 'Biblioteca', link: 'https://biblioteca.ibero.edu.co/', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/sistema_biblioteca.jpg', target: '_blank' },
            { id: '11', title: 'Calendario académico Ibero', detail: 'Ver Calendario', link: 'https://www.ibero.edu.co/2019/02/04/calendario-academico-pregrado-y-posgrado-2019/', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/Calendario_academico.jpg', target: '_blank' },
            { id: '17', title: 'Manual inscripción de materias', detail: 'Accede', link: 'https://www.ibero.edu.co/wp-content/uploads/2020/07/Manual-Inscripcion-2020-08-2020.pdf', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/manual_inscripcion_materias.jpg', target: '_blank' },
            { id: '18', title: '¿Cómo acceder a los horarios?', detail: 'Accede', link: 'https://www.ibero.edu.co/wp-content/uploads/2020/07/Como-acceder-a-los-horarios-08-2020.pdf', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/como_acceder_horarios.jpg', target: '_blank' },
            { id: '19', title: 'Inscripción de cursos', detail: 'Accede', link: 'https://www.ibero.edu.co/wp-content/uploads/2020/07/Inscripcion-de-cursos-08-2020.pdf', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/inscripcion_cursos.jpg', target: '_blank' },
            { id: '20', title: 'Cómo inscribir NRCs en Zafiro', detail: 'Accede', link: 'https://www.ibero.edu.co/wp-content/uploads/2020/07/Como-inscribir-NRCs-en-Zafiro-08-2020.pdf', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/inscripcion_NRC.jpg', target: '_blank' },
            { id: '21', title: 'Errores comunes en la inscripción de materias', detail: 'Accede', link: 'https://www.ibero.edu.co/wp-content/uploads/2020/07/Manual-Inscripcion-errores-08-2020.pdf', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/errores_inscripcion_materias.jpg', target: '_blank' },
            { id: '26', title: 'Solicitar Copia de Recibo de Pago', detail: 'Accede', link: '/copia-recibo', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/copia_recibo_pago.jpg', target: '_self' },
            { id: '27', title: 'Restablecimiento Contraseña de Correo Electrónico', detail: 'Accede', link: '/restablecer-contrasena-correo', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/restablecer_contrase%C3%B1a_correo.jpg', target: '_self' },
            { id: '22', title: 'App Ibero Android', detail: 'Accede', link: 'https://play.google.com/store/apps/details?id=com.planeta.ibero', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/app_android.jpg', target: '_blank' },
            { id: '23', title: 'APP Ibero IOS', detail: 'Accede', link: 'https://apps.apple.com/py/app/universitaria-ibero/id1524578923', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/app_ios.jpg', target: '_blank' },
            { id: '24', title: 'Consulta tu asesor', detail: 'Accede', link: '/asesores', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/consulta_asesor.jpg', target: '_self' },
            { id: '25', title: 'Actualización de datos de Egresados', detail: 'Accede', link: '/egresados', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/actualiazacion_datos_egresados.jpg', target: '_self' },
            { id: '26', title: 'Recibo de Pago Certificados', detail: 'Accede', link: '/recibo-pago-certificado', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/recibo_pagos_certificados.jpg', target: '_self' },
            { id: '26', title: 'Test Vocacional', detail: 'Accede', link: '/test_vocacional', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/inscripcion_NRC.jpg', target: '_self' },
            { id: '27', title: 'Evento Investigaciones Fonoaudiología', detail: 'Accede', link: '/evento-investigaciones', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/formulario_inscripcion.jpg', target: '_self' },
        ],
        IberoVirtual: [
            { id: '1', title: 'Plataforma Virtual Moodle Ibero', detail: 'Plataforma Moodle Ibero', link: 'https://iberoamericana.mrooms.net/', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/plataforma_virtual_moodle.jpg', target: '_blank' },
            { id: '2', title: 'Guía estudiantes virtuales Ibero', detail: 'Ver Video', link: 'https://aulavirtual.iberoamericana.edu.co/recursosel/te_guiamos/', img: 'https://services.ibero.edu.co/Files/ImagenesPortales/Campusvirtual/guia_estudiantes_virtuales.jpg', target: '_blank' }
        ],
        IberoCampus: [
            { id: '1', title: 'Actualizacion de Datos', detail: 'Accede', link: '/Account', img: 'https://www.ibero.edu.co/wp-content/uploads/2019/08/restablece-clave-de-zafiro.png', target: '_self' },
            { id: '2', title: 'Votaciones Iberoamericana', detail: 'Accede', link: '/Voting', img: 'https://www.ibero.edu.co/wp-content/uploads/2018/01/woman-higher-education-teamwork-designer-folded_1134-923-300x210.jpg', target: '_self' }
        ],
        /*listAddress: [
            { id:'1', value:'Calle', nom:'CA'},
            { id:'2', value:'Carrera', nom:'CR'},
            { id:'3', value:'Avenida', nom:'AV'},
            { id:'4', value:'Avenida Carrera', nom:'AC'},
            { id:'5', value:'Avenida Calle', nom:'ACA'},
            { id:'6', value:'Circular', nom:'CIR'},
            { id:'7', value:'Circunvalar', nom:'CRL'},
            { id:'8', value:'Diagonal', nom:'DG'},
            { id:'9', value:'Manzana', nom:'MZ'},
            { id:'10', value:'Transversal', nom:'TR'},
            { id:'11', value:'Vía', nom:'VI'},
            { id:'12', value:'Vereda', nom:'VE'}
        ],*/
        listAddress: [
            { id: '1', nomenclature: 'AC', value: 'Avenida calle' },
            { id: '2', nomenclature: 'AD', value: 'Administración' },
            { id: '3', nomenclature: 'ADL', value: 'Adelante' },
            { id: '4', nomenclature: 'AER', value: 'Aeropuerto' },
            { id: '5', nomenclature: 'AG', value: 'Agencia' },
            { id: '6', nomenclature: 'AGP', value: 'Agrupación' },
            { id: '7', nomenclature: 'AK', value: 'Avenida carrera' },
            { id: '8', nomenclature: 'AL', value: 'Altillo' },
            { id: '9', nomenclature: 'ALD', value: 'Al lado' },
            { id: '10', nomenclature: 'ALM', value: 'Almacén' },
            { id: '11', nomenclature: 'AP', value: 'Apartamento' },
            { id: '12', nomenclature: 'APTDO', value: 'Apartado' },
            { id: '13', nomenclature: 'ATR', value: 'Atrás' },
            { id: '14', nomenclature: 'AUT', value: 'Autopista' },
            { id: '15', nomenclature: 'AV', value: 'Avenida' },
            { id: '16', nomenclature: 'AVIAL', value: 'Anillo vial' },
            { id: '17', nomenclature: 'BG', value: 'Bodega' },
            { id: '18', nomenclature: 'BL', value: 'Bloque' },
            { id: '19', nomenclature: 'BLV', value: 'Boulevard' },
            { id: '20', nomenclature: 'BRR', value: 'Barrio' },
            { id: '21', nomenclature: 'C', value: 'Corregimiento' },
            { id: '22', nomenclature: 'CA', value: 'Casa' },
            { id: '23', nomenclature: 'CAS', value: 'Caserío' },
            { id: '24', nomenclature: 'CC', value: 'Centro comercial' },
            { id: '25', nomenclature: 'CD', value: 'Ciudadela' },
            { id: '26', nomenclature: 'CEL', value: 'Célula' },
            { id: '27', nomenclature: 'CEN', value: 'Centro' },
            { id: '28', nomenclature: 'CIR', value: 'Circular' },
            { id: '29', nomenclature: 'CL', value: 'Calle' },
            { id: '30', nomenclature: 'CLJ', value: 'Callejón' },
            { id: '31', nomenclature: 'CN', value: 'Camino' },
            { id: '32', nomenclature: 'CON', value: 'Conjunto residencial' },
            { id: '33', nomenclature: 'CONJ', value: 'Conjunto' },
            { id: '34', nomenclature: 'CR', value: 'Carrera' },
            { id: '35', nomenclature: 'CRT', value: 'Carretera' },
            { id: '36', nomenclature: 'CRV', value: 'Circunvalar' },
            { id: '37', nomenclature: 'CS', value: 'Consultorio' },
            { id: '38', nomenclature: 'DG', value: 'Diagonal' },
            { id: '39', nomenclature: 'DP', value: 'Depósito' },
            { id: '40', nomenclature: 'DPTO', value: 'Departamento' },
            { id: '41', nomenclature: 'DS', value: 'Depósito sótano' },
            { id: '42', nomenclature: 'ED', value: 'Edificio' },
            { id: '43', nomenclature: 'EN', value: 'Entrada' },
            { id: '44', nomenclature: 'ES', value: 'Escalera' },
            { id: '45', nomenclature: 'ESQ', value: 'Esquina' },
            { id: '46', nomenclature: 'ESTE', value: 'Este' },
            { id: '47', nomenclature: 'ET', value: 'Etapa' },
            { id: '48', nomenclature: 'EX', value: 'Exterior' },
            { id: '49', nomenclature: 'FCA', value: 'Finca' },
            { id: '50', nomenclature: 'GJ', value: 'Garaje' },
            { id: '51', nomenclature: 'GS', value: 'Garaje sótano' },
            { id: '52', nomenclature: 'GT', value: 'Glorieta' },
            { id: '53', nomenclature: 'HC', value: 'Hacienda' },
            { id: '54', nomenclature: 'HG', value: 'Hangar' },
            { id: '55', nomenclature: 'IN', value: 'Interior' },
            { id: '56', nomenclature: 'IP', value: 'Inspección de Policía' },
            { id: '57', nomenclature: 'IPD', value: 'Inspección Departamental' },
            { id: '58', nomenclature: 'IPM', value: 'Inspección Municipal' },
            { id: '59', nomenclature: 'KM', value: 'Kilómetro' },
            { id: '60', nomenclature: 'LC', value: 'Local' },
            { id: '61', nomenclature: 'LM', value: 'Local mezzanine' },
            { id: '62', nomenclature: 'LT', value: 'Lote' },
            { id: '63', nomenclature: 'MD', value: 'Módulo' },
            { id: '64', nomenclature: 'MJ', value: 'Mojón' },
            { id: '65', nomenclature: 'MLL', value: 'Muelle' },
            { id: '66', nomenclature: 'MN', value: 'Mezzanine' },
            { id: '67', nomenclature: 'MZ', value: 'Manzana' },
            { id: '68', nomenclature: 'NOMBRE VIA', value: 'Vías de nombre común' },
            { id: '69', nomenclature: 'NORTE', value: 'Norte' },
            { id: '70', nomenclature: 'O', value: 'Oriente' },
            { id: '71', nomenclature: 'OCC', value: 'Occidente' },
            { id: '72', nomenclature: 'OESTE', value: 'Oeste' },
            { id: '73', nomenclature: 'OF', value: 'Oficina' },
            { id: '74', nomenclature: 'P', value: 'Piso' },
            { id: '75', nomenclature: 'PA', value: 'Parcela' },
            { id: '76', nomenclature: 'PAR', value: 'Parque' },
            { id: '77', nomenclature: 'PD', value: 'Predio' },
            { id: '78', nomenclature: 'PH', value: 'Penthouse' },
            { id: '79', nomenclature: 'PJ', value: 'Pasaje' },
            { id: '80', nomenclature: 'PL', value: 'Planta' },
            { id: '81', nomenclature: 'PN', value: 'Puente' },
            { id: '82', nomenclature: 'POR', value: 'Portería' },
            { id: '83', nomenclature: 'POS', value: 'Poste' },
            { id: '84', nomenclature: 'PQ', value: 'Parqueadero' },
            { id: '85', nomenclature: 'PRJ', value: 'Paraje' },
            { id: '86', nomenclature: 'PS', value: 'Paseo' },
            { id: '87', nomenclature: 'PT', value: 'Puesto' },
            { id: '88', nomenclature: 'PW', value: 'Park Way' },
            { id: '89', nomenclature: 'RP', value: 'Round Point' },
            { id: '90', nomenclature: 'SA', value: 'Salón' },
            { id: '91', nomenclature: 'SC', value: 'Salón comunal' },
            { id: '92', nomenclature: 'SD', value: 'Salida' },
            { id: '93', nomenclature: 'SEC', value: 'Sector' },
            { id: '94', nomenclature: 'SL', value: 'Solar' },
            { id: '95', nomenclature: 'SM', value: 'Súper manzana' },
            { id: '96', nomenclature: 'SS', value: 'Semisótano' },
            { id: '97', nomenclature: 'ST', value: 'Sótano' },
            { id: '98', nomenclature: 'SUITE', value: 'Suite' },
            { id: '99', nomenclature: 'SUR', value: 'Sur' },
            { id: '100', nomenclature: 'TER', value: 'Terminal' },
            { id: '101', nomenclature: 'TERPLN', value: 'Terraplén' },
            { id: '102', nomenclature: 'TO', value: 'Torre' },
            { id: '103', nomenclature: 'TV', value: 'Transversal' },
            { id: '104', nomenclature: 'TZ', value: 'Terraza' },
            { id: '105', nomenclature: 'UN', value: 'Unidad' },
            { id: '106', nomenclature: 'UR', value: 'Unidad residencial' },
            { id: '107', nomenclature: 'URB', value: 'Urbanización' },
            { id: '108', nomenclature: 'VRD', value: 'Vereda' },
            { id: '109', nomenclature: 'VTE', value: 'Variante' },
            { id: '110', nomenclature: 'ZF', value: 'Zona franca' },
            { id: '111', nomenclature: 'ZN', value: 'Zona' }
        ],
        listEstrato: [
            { id: '1', value: '1' },
            { id: '2', value: '2' },
            { id: '3', value: '3' },
            { id: '4', value: '4' },
            { id: '5', value: '5' },
            { id: '6', value: '6' }
        ],
        listWork: [
            { id: 'Si, tiempo Completo', value: 'Si, tiempo Completo' },
            { id: 'Si, medio Tiempo', value: 'Si, medio Tiempo' },
            { id: 'Si, temporalmente', value: 'Si, temporalmente' },
            { id: 'No trabajo', value: 'No trabajo' }
        ],
        listPersons: [
            { id: '0', value: '0' },
            { id: '1', value: '1' },
            { id: '2', value: '2' },
            { id: '3', value: '3' },
            { id: '4', value: '4' },
            { id: '5', value: '5' }
        ],
        listMAterial: [
            { id: 'Computador, Conexión a internet, Audífonos, Microsoft (Word, Power point, Excel)', value: 'Computador, Conexión a internet, Audífonos, Microsoft (Word, Power point, Excel)' },
            { id: 'Computador, Conexión a internet, Audífonos', value: 'Computador, Conexión a internet, Audífonos' },
            { id: 'Computador, Conexión a internet', value: 'Computador, Conexión a internet' },
            { id: 'Computador', value: 'Computador' },
            { id: 'No cuento con herramientas', value: 'No cuento con herramientas' }
        ],
        DocTypesList: [],
        DocTypesListICFES: [],
        StateList: [],
        CityList: [],
        CitiesList: [],
        SchoolList: [],
        CityListRes: [],
        CityListBirth: [],
        CityListCol: [],
        OperatorList: [],
        DesabilityList: [],
        EthnicityList: [],
        MaritalStatusList: [],
        GenderList: [],
        WorkdayList: [],
        ModalityList: [],
        DegreeList: [],
        CountriesList: [],
        AsesorList: [],
        BondsList: [],
        PQRSList: [],
        ProgramsList: [],
        ModalitiesList: [],
        ItemList: [],
        SelectList: [],
        TipocColegioList: [],
        JornadaList: [],
        ProgramList: [],
        WorkdayList: [],
        CertificatesList: [],
        PeriodoList: [],
        HomDegreeList: [],
        DegreeDocumentList: {},
        EPSList: [],
        EPSQAList: [],
        EtniaList: [],
        PlanList: [],
    },
    mutations: {},
    actions: {
        callIberoWS: function () {
            this.state.localInf = Response.data;
            IberoHelpers.getDocTypeList(this);
            IberoHelpers.getStateList(this);
            IberoHelpers.getOperatorList(this);
            IberoHelpers.getDesabilityList(this);
            IberoHelpers.getEthnicityList(this);
            IberoHelpers.getMaritalStatusList(this);
            IberoHelpers.getGenderList(this);
            IberoHelpers.getDegreeList(this);
            IberoHelpers.getDegreeDocumentList(this);
            IberoHelpers.getCountriesList(this);
            IberoHelpers.getBondsList(this);
            IberoHelpers.getPQRSList(this);
            IberoHelpers.getProgramsList(this);
            IberoHelpers.getAllCertificateType(this);
            IberoHelpers.getModalitiesList(this);
            IberoHelpers.getSchoolTypeList(this);
            IberoHelpers.getEPSList(this);
            IberoHelpers.getEPSQAList(this);
            IberoHelpers.getWorkdaySchoolList(this);
            IberoHelpers.getWorkdayList(this);
            IberoHelpers.getPeriodList(this);
        }
    },
    modules: {}
})